import React, { useState, useEffect } from 'react';
import './Loading.css';

export default function Loading() {
  const loadingMessages = [
    "Loading awesome content...",
    "Just a moment...",
    "Preparing something special...",
    "Almost there...",
    "Getting things ready...",
    "Hang tight...",
    "Magic in progress...",
    "Loading your experience...",
    "Please wait...",
    "Good things take time..."
  ];

  const [messageIndex, setMessageIndex] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setMessageIndex((prev) => (prev + 1) % loadingMessages.length);
    }, 2000);

    return () => clearInterval(interval);
  }, []);

  return (
    <div className="loading-container">
      {/* Animated Bars */}
      <div className="bars-wrapper">
        <div className="bar bar-1"></div>
        <div className="bar bar-2"></div>
        <div className="bar bar-3"></div>
        <div className="bar bar-4"></div>
        <div className="bar bar-5"></div>
        <div className="bar bar-6"></div>
        <div className="bar bar-7"></div>
      </div>

      {/* Dynamic Loading Text */}
      <div className="text-container">
        <h2 className="loading-message" key={messageIndex}>
          {loadingMessages[messageIndex]}
        </h2>
        
        {/* Animated Dots */}
        <div className="dots-container">
          <div className="dot dot-1"></div>
          <div className="dot dot-2"></div>
          <div className="dot dot-3"></div>
        </div>
      </div>
    </div>
  );
}